// extracted by mini-css-extract-plugin
export default {"iconArrowRight":"IconArrowRight_iconArrowRight__4-wFw"};